import type { SchemaField } from '@cli-types/core-engine/schema.js'
import type { FieldRenderContext } from '@cli-types/next-adapter/forms.js'
import { toPascalCase } from '@cli-utils/text.js'
import { formItemProps } from '@next-adapter/generators/form/form-shared/form-item-props.js'
import { formLabel } from '@next-adapter/generators/form/form-shared/form-label.js'
import { labelWithDescription } from '@next-adapter/generators/form/form-shared/label-with-description.js'
import { renderSingleRelationshipFieldActionButtonsTemplate } from '@next-adapter/templates/renderers/generators/form/field-jsx/render-single-relationship-field.js'
import { defaultValueFromSourceHandler } from './default-value-from-source-handler.js'

export function renderSingleRelationshipField(
  field: SchemaField,
  indent: string,
  label: string,
  hintJSX: string,
  displayField: string,
  secondaryDisplayField: string,
  dataArray: string,
  relSingular: string,
  context: FieldRenderContext
): string {
  const defaultValueFromHandler = defaultValueFromSourceHandler(field, context)
  return renderSingleRelationshipFieldActionButtonsTemplate({
    indent: indent,
    fieldName: field.name,
    formItemProps: formItemProps(field, 'flex flex-col'),
    labelWithDescription: labelWithDescription(formLabel(field, label), hintJSX, `${indent}      `),
    toPascalCase: toPascalCase(field.name),
    dataArray: dataArray,
    displayField: displayField,
    toLowerCase: label.toLowerCase(),
    relSingular: relSingular,
    secondaryDisplayField: secondaryDisplayField,
    defaultValueFromHandlerContent: defaultValueFromHandler
      ? `${indent}                        ${defaultValueFromHandler}(String(item.id))\n`
      : ''
  })
}
